import appStyles from "../../../App.module.css";

const LoadingModal = () => {
  return (
    <div className={`${appStyles.btModalDetailWrap} ${appStyles.btLoadingModalDetailWrap}`}>
      <div className={appStyles.btModalIconWrap}>
        <svg width="32" height="38" viewBox="0 0 32 38" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path
            d="M22.6255 0H9.37169L0 9.2199V22.2591L9.37169 31.4791L16.0001 38L32 22.2591V9.2199L22.6255 0ZM20.4092 20.0787C17.9733 22.4751 14.0238 22.4751 11.588 20.0787C9.15209 17.6823 9.15209 13.7967 11.588 11.4003C14.0238 9.00388 17.9733 9.00388 20.4092 11.4003C22.8451 13.7967 22.8451 17.6823 20.4092 20.0787Z"
            fill="black"
          />
        </svg>
      </div>

      <p className={appStyles.btModalSubTitle}>We’re getting your quote together...</p>
    </div>
  );
};

export default LoadingModal;
